import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-engine-result',
  templateUrl: './engine-result.component.html',
  styleUrls: ['./engine-result.component.scss']
})
export class EngineResultComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
